import * as React from 'react'

import { ENTITY_TYPES } from '@sales-center/common'
import { LeadNote, OpportunityNote } from '../typings'
import { NoteCard } from './NoteCard'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Pagination from '@mui/material/Pagination'
import Stack from '@mui/material/Stack'
import { useCombinedNotes } from '@user/components/Notes/EntityNotes/hooks/useCombinedNotes'
import { NoteDetailsProps } from '@user/components/Leads/LeadCard/NotesDrawer/typings'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

interface Props {
  count: number
  entityId: number
  entityType: ENTITY_TYPES
  notes: LeadNote[] | OpportunityNote[]
  onChangePage: (pageNumber: number) => void
  page: number
  take: number
  canUpdate?: boolean
  showPestPacNote?: boolean
  showKnockStatusNote?: boolean
  backToNotes?: boolean
  externalLinkId: string
  sortBy: string
  onUpdate: () => void
  setBackToNotes?: (value: boolean, id: number) => void
  detail: NoteDetailsProps
}

export function NoteList(props: Props) {
  const {
    count,
    entityId,
    entityType,
    notes,
    onChangePage,
    page,
    take,
    canUpdate,
    showPestPacNote = false,
    showKnockStatusNote = true,
    externalLinkId,
    sortBy,
    onUpdate,
    detail,
    backToNotes,
    setBackToNotes,
  } = props
  const { combinedNotes, groupedNotes } = useCombinedNotes(
    detail,
    notes,
    showPestPacNote,
    showKnockStatusNote,
    sortBy,
    externalLinkId,
  )
  const pageCount = Math.ceil(count / take)
  const theme = useTheme()
  return (
    <Stack marginX={0}>
      {combinedNotes.length >= 1 && (
        <>
          {groupedNotes.map((item, index) => (
            <Box mb={3} key={index}>
              <Typography
                variant="subtitle3"
                color={theme.palette.text.primary}
              >
                {item.createdDate}
              </Typography>
              <Stack gap={1.5} mt={1}>
                {item.notes.map((note, noteIndex) => (
                  <NoteCard
                    key={noteIndex}
                    canUpdate={canUpdate}
                    entityId={entityId}
                    entityType={entityType}
                    note={note}
                    externalLinkId={externalLinkId}
                    onUpdate={onUpdate}
                    backToNotes={backToNotes}
                    setBackToNotes={setBackToNotes}
                  />
                ))}
              </Stack>
            </Box>
          ))}

          {pageCount > 1 && (
            <Box display="flex" justifyContent="flex-end">
              <Pagination
                count={pageCount}
                color="primary"
                page={page}
                onChange={(_e, newPage) => {
                  onChangePage(newPage)
                }}
              />
            </Box>
          )}
        </>
      )}

      {(!externalLinkId || (externalLinkId && showPestPacNote)) &&
        combinedNotes.length == 0 && (
          <Alert severity="info" sx={{ marginBottom: theme.spacing(2) }}>
            No notes to show
          </Alert>
        )}
    </Stack>
  )
}
